export default __webpack_public_path__ + "static/media/healthcare-header.37b861ac.svg";